export default class LiveEvent {
  constructor(client) {
    this.client = client;
  }

  subscribeLiveReading(resourceId, readingId) {
    const requestKey = "liveevent.subscribeLiveReading";

    let params = {
      topic: resourceId + "/" + readingId,
    };

    return this.client._postMessageWithPromise(requestKey, params);
  }

  subscribeUserEvent(topic) {
    const requestKey = "liveevent.subscribeUserEvent";

    let params = {
      topic: topic,
    };

    return this.client._postMessageWithPromise(requestKey, params);
  }

  subscribeOrgEvent(topic) {
    const requestKey = "liveevent.subscribeOrgEvent";

    let params = {
      topic: topic,
    };

    return this.client._postMessageWithPromise(requestKey, params);
  }

  subscribeAppEvent(topic) {
    const requestKey = "liveevent.subscribeAppEvent";

    let params = {
      topic: topic,
    };

    return this.client._postMessageWithPromise(requestKey, params);
  }

  unsubscribe(token) {
    const requestKey = "liveevent.unsubscribe";

    let params = {
      token: token,
    };

    return this.client._postMessageWithPromise(requestKey, params);
  }
}
